import { FC } from 'react';
import { Calendar } from 'lucide-react';
import { ChipPopover } from './ChipPopover';

export const DATE_PRESETS = [
  'Oggi',
  'Ieri',
  'Ultimi 7 giorni',
  'Ultimi 14 giorni',
  'Ultimi 30 giorni',
  'Mese corrente',
  'Mese scorso',
  'Trimestre corrente',
  'Personalizzato…',
];

type DateRangeChipProps = {
  value: string;
  onChange: (preset: string) => void;
};

export const DateRangeChip: FC<DateRangeChipProps> = ({ value, onChange }) => {
  return (
    <ChipPopover icon={<Calendar size={14} color='currentColor' />} value={value} popWidth={220} popAlign='right' marginLeftAuto>
      {(close) => (
        <div style={{ padding: 6 }}>
          {DATE_PRESETS.map((p, i) => {
            const isOn = p === value;
            const showSep = i === 5 || i === 8;
            return (
              <div key={p}>
                <div
                  onClick={() => {
                    if (p === 'Personalizzato…') return;
                    onChange(p);
                    close();
                  }}
                  style={{
                    padding: '8px 10px',
                    fontSize: 13,
                    color: isOn ? '#0F3FBD' : '#344155',
                    borderRadius: 6,
                    cursor: p === 'Personalizzato…' ? 'not-allowed' : 'pointer',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    background: isOn ? '#E8EFFF' : 'transparent',
                    fontWeight: isOn ? 600 : 400,
                    opacity: p === 'Personalizzato…' ? 0.55 : 1,
                  }}
                  onMouseEnter={(e) => {
                    if (!isOn && p !== 'Personalizzato…') (e.currentTarget as HTMLElement).style.background = '#F7F8FA';
                  }}
                  onMouseLeave={(e) => {
                    if (!isOn) (e.currentTarget as HTMLElement).style.background = 'transparent';
                  }}
                >
                  <span>{p}</span>
                  {isOn ? <span style={{ fontSize: 11 }}>✓</span> : null}
                </div>
                {i === 4 || i === 7 ? <div style={{ height: 1, background: '#F0F2F5', margin: '4px 6px' }} /> : null}
                {showSep ? null : null}
              </div>
            );
          })}
        </div>
      )}
    </ChipPopover>
  );
};
